import { render, staticRenderFns } from "./manualhandlingdetails.vue?vue&type=template&id=f222bb88"
import script from "./manualhandlingdetails.vue?vue&type=script&lang=js"
export * from "./manualhandlingdetails.vue?vue&type=script&lang=js"
import style0 from "./manualhandlingdetails.vue?vue&type=style&index=0&id=f222bb88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports